import { useState, useCallback } from 'react';
import { MCPServer } from '@/shared/types';
import { mcpApi } from '../../../services/mcpApi';

export const useToolExecution = (selectedServer: MCPServer | null) => {
  const [executingTool, setExecutingTool] = useState<any>(null);
  const [executionResults, setExecutionResults] = useState<Record<string, any>>({});

  const handleExecuteTool = useCallback(async (toolData: any) => {
    if (!selectedServer || !executingTool) return { success: false, error: 'No server or tool selected' };
    
    try {
      // Here you would call the MCP API to execute the tool
      // For now, we'll simulate the execution
      const response = await mcpApi.executeTool(selectedServer.id, executingTool.name, toolData);
      
      if (response.success) {
        console.log('🔧 MCP Frontend: Setting execution result for server:', selectedServer.id, response.data);
        setExecutionResults(prev => ({
          ...prev,
          [selectedServer.id]: response.data
        }));
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.error || 'Tool execution failed' };
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Tool execution failed';
      return { success: false, error: errorMessage };
    }
  }, [selectedServer, executingTool]);

  const handleStartToolExecution = useCallback((tool: any) => {
    setExecutingTool(tool);
    // Don't clear execution result immediately - let it show until new execution completes
  }, []);

  const handleCancelToolExecution = useCallback(() => {
    setExecutingTool(null);
    if (selectedServer) {
      setExecutionResults(prev => ({
        ...prev,
        [selectedServer.id]: null
      }));
    }
  }, [selectedServer]);

  const getExecutionResult = useCallback(() => {
    return selectedServer ? executionResults[selectedServer.id] : null;
  }, [selectedServer, executionResults]);

  return {
    executingTool,
    executionResults,
    handleExecuteTool,
    handleStartToolExecution,
    handleCancelToolExecution,
    getExecutionResult,
  };
};
